import './LoginPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import update from 'immutability-helper';

import { updateTitle } from 'containers/App/store/actions';
import { clearError, login, updateAuth, updateCredentials } from '../store/actions';
import { USER_ROLES } from 'utils/constants';

import LoginForm from './LoginForm';
import Content from 'components/Content';

class LoginPage extends React.Component {
    componentWillMount() {
        this.props.updateTitle('Login');
        document.body.classList.add('auth-page');

        //Clear the session timer set on the homepage
        window.clearTimeout(this.props.auth.sessionTimer);
    }

    componentWillUnmount() {

        this.props.clearError();
    }

    _handleChange(event) {
        let newAuthObj = update(this.props.auth.credentials, {});
        newAuthObj[event.target.getAttribute('name')] = event.target.value;
        this.props.updateCredentials(newAuthObj);
    }

    _handleSubmit(isValid) {
        this.clearError();
        if(isValid === true) {
            this.props.login((hasAccess) => {
                if(hasAccess === true) {
                    console.log(this.props.auth.role);
                    if (this.props.auth.role == USER_ROLES.DEITY) {
			location.href="dashboard";
                    } else if (this.props.auth.role !== USER_ROLES.ADMIN && this.props.auth.role !== USER_ROLES.CREATOR_ADMIN) {
                        this.props.changeLocation('/download');
                        document.body.classList.add('not-admin');
                        document.body.classList.remove('auth-page');
                    } else {
                        this.props.changeLocation('/assignments');
                        document.body.classList.remove('not-admin');
                        document.body.classList.remove('auth-page');
                    }
                }
            });
        }
    }

    clearError() {
        this.props.updateAuth(update(this.props.auth, {error: {$set: {}}}));
    }

    render() {
        let { auth } = this.props;
        return (
            <Content className="login-form--wrapper">
                <LoginForm handleChange={this._handleChange.bind(this)}
                           isTestingAuth={this.props.auth.isTestingAuth}
                           onValid={this._handleSubmit.bind(this, true)}
                           onInvalid={this._handleSubmit.bind(this, false)}
                           credentials={auth.credentials}
                           authError={this.props.auth.error} />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearError: () => dispatch(clearError()),
        login: (funcCallback) => dispatch(login(funcCallback)),
        updateAuth: (obj) => dispatch(updateAuth(obj)),
        updateCredentials: (obj) => dispatch(updateCredentials(obj)),
        updateTitle: (string) => dispatch(updateTitle(string))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/LoginPage/index.js